import React, { useEffect } from "react";
import "../../stepper.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const StaffGrid = ({
  displayedData,
  getStartingSerialNumber,
  ResendEmail,
  formatDate,
  openEditModal,
  ViewDetails,
  openEditV2PRMModal,
  GridType,
}) => {
  const details = useSelector((state) => state.details.details);
  const lastCompletedStep = details?.result?.lastCompletedStep;
  const location = useLocation();
  const route = location.pathname.split("/").pop();
  useEffect(() => {
    console.log(route);
  }, []);

  return (
    <>
      <div className="overflow-x-auto mt-2 border rounded-md shadow-sm shadow-sm">
        <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y  divide-gray-200">
          <thead className="bg-gray-400">
            <tr>
              <th
                scope="col"
                className="px-2 py-4 text-center text-xs font-medium text-white uppercase tracking-wider w-16"
              >
                Sr. No.
              </th>
              <th
                scope="col"
                className="px-2 py-4 text-left text-xs font-medium text-white uppercase tracking-wider w-40"
              >
                Merchant
              </th>
              <th
                scope="col"
                className="px-2 py-4 text-left text-xs font-medium text-white uppercase tracking-wider w-36"
              >
                Email
              </th>
              <th
                scope="col"
                className="px-2 py-4 text-left text-xs font-medium text-white uppercase tracking-wider w-24"
              >
                Phone
              </th>
              <th
                scope="col"
                className="px-2 py-4 text-left text-xs font-medium text-white uppercase tracking-wider w-24"
              >
                Partner Bank
              </th>
              <th
                scope="col"
                className="px-2 py-4 text-left text-xs font-medium text-white uppercase tracking-wider w-24"
              >
                Program
              </th>
              <th
                scope="col"
                className="px-2 py-4 text-left text-xs font-medium text-white uppercase tracking-wider w-20"
              >
                Date
              </th>
              <th
                scope="col"
                className="px-2 py-4 text-left text-xs font-medium text-white uppercase tracking-wider w-32"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 ">
            {displayedData?.map((item, index) => (
              <tr
                style={{
                  color:
                    item.approvalStatus === 2 && GridType === "pending"
                      ? "red"
                      : "",
                }}
                key={"mailsent" + index}
                className="border-t"
              >
                <td className="px-2 py-1 border-r-2 text-center whitespace-nowrap">
                  {getStartingSerialNumber() + index}
                </td>
                <td className="px-2 py-1 border-r-2 whitespace-nowrap">
                  {item.customerName}
                </td>
                <td className="px-2 py-1 border-r-2 whitespace-nowrap">
                  {item.email}
                </td>
                <td className="px-2 py-1 border-r-2 whitespace-nowrap">
                  {item.phone}
                </td>
                <td className="px-2 py-1 border-r-2 whitespace-nowrap">
                  {item.partnerBankName}
                </td>
                <td className="px-2 py-1 border-r-2 whitespace-nowrap">
                  {item.program}
                </td>
                <td className="px-2 py-1 border-r-2 whitespace-nowrap">
                  {item.createdAt !== null || item.createdAt !== ""
                    ? formatDate(item.createdAt)
                    : item.createdAt}
                </td>
                <td className="px-2 py-1 whitespace-nowrap">
                  {GridType === "mail-sent" ? (
                    <>
                      <button
                        title="Resend Email"
                        onClick={() => ResendEmail(item.id)}
                        className="resend-mail px-2 py-1 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-6 h-6"
                        >
                          <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                          <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                        </svg>
                        {/* <ToolTipComponent anchorElement="resend-mail" tooltipText="Resend Mail" /> */}
                      </button>

                      <button
                        title="Edit Email/Phone"
                        onClick={() => openEditModal(item)}
                        className="edit-mail-phone px-2 py-1 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-6 h-6"
                        >
                          <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                          <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
                        </svg>
                        {/* <ToolTipComponent anchorElement="edit-mail-phone" tooltipText="Edit Email/Phone" /> */}
                      </button>
                      <button
                        title="Change RM"
                        onClick={() => openEditV2PRMModal(item)}
                        className="change-rm px-2 py-1 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {/* <ToolTipComponent anchorElement="change-rm" tooltipText="Change RM" /> */}
                      </button>
                    </>
                  ) : (
                    ""
                  )}

                  {GridType === "pending" || GridType === "accepted" ? (
                    <>
                      <button
                        title="View Detail"
                        onClick={() => ViewDetails(item, "pending")}
                        className="px-2 py-1 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-6 h-6"
                        >
                          <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                          <path
                            fillRule="evenodd"
                            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                      <button
                        title="Change RM"
                        onClick={() => openEditV2PRMModal(item)}
                        className="px-2 py-1 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default StaffGrid;
